export default [
  { name: 'Position', prop: 'position', type: 'number', min: 1 },
  {
    name: 'Webinar',
    prop: 'webinar_id',
    type: 'autocomplete',
    references: 'admin/webinars',
    referenceProp: 'title',
    displayProp: 'long_title',
    query: {
      filters: {
        type: 'curriculum'
      }
    }
  }
]
